import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7d243b86/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Editing is making changes to a resource that already exists in the system.
Updating and editing should use the same behavior as when the resource is created. This should only vary in situations where the number of editable fields is significantly smaller or larger than during creation, or the context of current settings is required.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview/"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainers"
    }}>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/chloepoulterdesign"
      }}>{`Chloe Poulter`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Low-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">High-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Optional extras</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "60.670731707317074%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB9UlEQVQoz62Ty4/SUBTG5y8zcWPCgpeDCzOAyWDiUt2oWxKMlT54I48pFIHShDVbwgLZu1CYxIWJkxCCi1oeLYXh8547Y8wMupsmX85t79ffOfdrerTf73FXF7GOaHG5u4RhtCEkkxBlhVURoiQjly8cqlDge+RJShLevhOg1jVst1sO5UDbdnAcegSf34+HxyH4AwEEmHw+H7xeLxOrvivRs0AwiOC1PB4Pnr94Cdd1/wJXqxVisafIZHKoVFVUz1RomoZ+v4/BYIDhcIjR6BPTiK9brRZqtRpUVUWpVEK327054Xq9QiQSgSiKyGazkNhRKpUqptMpFosFNpsNn4Besm2bg8ibSqUgyzJvcAu4RjgcvgWsYDabYblccgh5qFIDApInnU5zoK7r/wbSZrlc5tB6vc6BlmVxkO1s4GxcWAzYaDRYPBkUi0Ve2+32/yckUz6fR7PZxHw+h2maXJY5x/LXT9hLExprRs2pMVXyHgCj0SjfpKNS0GQaj8eYTMYYT87x5fsCX3+4OL9wcVZrsPwU5HI5KIpymCF95VAohEQiwXMhkyAIOD2NIXzyGCdPnuHBq8+49+YC919/Q1z4AEV6z3KUuY/iuQF0HAfxeJxnYxgGD5nU6XSupcPQm0wfuej+zx5N1+v1sNvtroB3/ev9BuwdBcebBlIAAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Contextual image of an edit modal",
        "title": "Contextual image of an edit modal",
        "src": "/static/0ff199fe8c2ea399d57c1d38d8478dd3/fb070/01.png",
        "srcSet": ["/static/0ff199fe8c2ea399d57c1d38d8478dd3/d6747/01.png 288w", "/static/0ff199fe8c2ea399d57c1d38d8478dd3/09548/01.png 576w", "/static/0ff199fe8c2ea399d57c1d38d8478dd3/fb070/01.png 1152w", "/static/0ff199fe8c2ea399d57c1d38d8478dd3/e8e91/01.png 1312w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an edit modal in context</Caption>
    <h2 {...{
      "id": "low-impact-edit"
    }}>{`Low-impact edit`}</h2>
    <p>{`For low-impact edits, allow editing with no warning. This approach is typically used when editing doesn’t have a wider impact.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA1ElEQVQoz82T2QqEMAxF/f+PLLQuBanWXcElMzcQqdTBh5mHKVxSk3iaWzSh9zqOg36xwEkEhvitsE7gsizkvaeu62gcx0dN03TRvu8xsG1bBobq+z7Koa+ua3LOUVmWrG3brsCmaUhrTdZayrKMVRQFGWMoz3NWmqacQ0QdUSnFPeu6XoHzPLNlTAS4TIu9TAVJPZwWMbIMIIrDMJxWIYEIAHXpg2VMjhhZDoFy6h1QcuirqorvD8+3QFiRF0JLkgv3j5ZxAi5W4ifd1ZE7v8O//1NeHJWnSpZk8SwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an edit button in a table",
            "title": "Example of an edit button in a table",
            "src": "/static/493118856d6627ed7661e0c6ab32a327/fb070/02.png",
            "srcSet": ["/static/493118856d6627ed7661e0c6ab32a327/d6747/02.png 288w", "/static/493118856d6627ed7661e0c6ab32a327/09548/02.png 576w", "/static/493118856d6627ed7661e0c6ab32a327/fb070/02.png 1152w", "/static/493118856d6627ed7661e0c6ab32a327/e8e91/02.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an edit button in a table</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "modal"
    }}>{`Modal`}</h3>
    <p>{`If an object was created in a modal, its editable fields can be made available in a modal. A modal can also be used where a small subset of fields are editable.
If enough fields are editable to require scrolling, use a side-panel or full-page edit dialog instead.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABCElEQVQoz52TTU7DMBCFeyw2bLkBK0oFrDkCEuEEPV8MYhHRlkysNI3z44g4D08iQ5OWqsbSkzPK05eZ53iGyeq6bvS8X5/yujU7ZpiCXD3VMegB0BnSNEUcx5BSoizLA3kDsyzroVVVoa5raK1/xLUxxg+Y5zmUUmiaZgRzwLM7dHtRFD1wCnP618icH4MLm5nqP/Ar4wvk7PhQBn1CxitIWmG3JXQtd2j8Ro6iCGEYQghh91eISOFt3UB8aLxvNNrWI0M+iCAIcDOf4/5ugduHR1w9Ey5fgIunL1wvDfJq8JpzO+RfhoiQJARKJDbb1gpYW9HOgvqJOaITN+Wv67T3dqTBOvZ/A7l3pLhT5JkFAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low consequence edit action in a modal",
            "title": "Example of a low consequence edit action in a modal",
            "src": "/static/dbd98522a0258a6fcc1550816df9778a/fb070/03.png",
            "srcSet": ["/static/dbd98522a0258a6fcc1550816df9778a/d6747/03.png 288w", "/static/dbd98522a0258a6fcc1550816df9778a/09548/03.png 576w", "/static/dbd98522a0258a6fcc1550816df9778a/fb070/03.png 1152w", "/static/dbd98522a0258a6fcc1550816df9778a/e8e91/03.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low consequence edit action in a modal</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "side-panel"
    }}>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, its editable fields can be made available in a side panel. A side panel can also be used where context in the main view of the screen is useful in the editing flow.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB50lEQVQoz62TzYvaYBDG9y/cldjantRL18Peei4LbVp3ozHGpH4QTW0tsqBSUEHw7n/hilBFtgVB/Exi9Ok702qxZQ+FBh5mEpjfvM/Mm7P9fo//9RDrjJPdDrXaHZRkEqqWFlGFmtJgvs/+VjYLPWMgoaqQ38XxWpbxRn6LV9fXKFhF+L7PUAY6rounz57j/PwCUvAJLgIBBISkYBCSJCEovtF7LBYTjVKIx+O4ubmFpmlIJBL4+OnzKXC9XuPF5SWfwCraKNkfUCqVYNs2x3K5jEKhgF6v97hd4fII3Gw2iEajSArLRiaDdFqDrut8AhLliqKg1WrBcRzM53Msl0vWYrHguPsTGIlEGJhhYPpEB2C73cZ2u2XIarViUQPSX8BwOAxVDJysZcUCDsrlciwCdzoduGLeBCCw53kcqf7RE1JxPp8/gk3T5NwwDAZOJhP0+30MBgPc3w8wHA4xm81wuH4nM0yJDVqWdRSBScVikeHdbhfT6RSj0Qjj8VjoK75/e8BmvToF0pZDoRBkcbfIGlknOEUSLYauSrPZ5CLPc7H1d3CFS9LK8U8t01yooFqtotFoiEteY9Xr9WNO3yuVCjKGCUNPQsl/wcu7Ha4qHm7bDjdg4L/+etSclvFTW7i/FnPg/AB1Jxj8XDzVAQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low-impact edit action in a side panel",
            "title": "Example of a low-impact edit action in a side panel",
            "src": "/static/8a24b12a96cb4d68bb4e0dba88ea3296/fb070/04.png",
            "srcSet": ["/static/8a24b12a96cb4d68bb4e0dba88ea3296/d6747/04.png 288w", "/static/8a24b12a96cb4d68bb4e0dba88ea3296/09548/04.png 576w", "/static/8a24b12a96cb4d68bb4e0dba88ea3296/fb070/04.png 1152w", "/static/8a24b12a96cb4d68bb4e0dba88ea3296/e8e91/04.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "high-impact-edit"
    }}>{`High-impact edit`}</h2>
    <p>{`Warn the user of the consequences of editing. This pattern is typically used when editing has a wider impact.
Inform users of the likely consequences of the edit to their system, and inform them that editing cannot be undone. Include a warning stage.`}</p>
    <h3 {...{
      "id": "modal-1"
    }}>{`Modal`}</h3>
    <p>{`A high-impact edit action of only a few fields can use a danger modal. A second confirm edit modal should also be inserted before the changes are saved. If desired, the confirmation modal can include a `}<a parentName="p" {...{
        "href": "#summary-of-changes"
      }}>{`summary of changes`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQoz62Ty07CQBSGeTW3JrrTlcYEwtKVLoxGWYAbEzcaNSkm+CAuWbkRUSlUjDEp5dYLlt4opb9zBjvoBjFxki/pTM9858yZNhXHMf5rkCtFD5PJBEEQcMIwxHg8FtA8iiIeMxqNxDwhiaH3NLiQFlRVRbfbhW3bcBxHQHMSDYdDKIqCZrPJ44x+n2MPBviwLIQsRggpk8UWSUCbk2oJ3/dF1X0m6PV6ME0Tpuei7bKkbL9HjumZZ0LP87iAhN8hIY1KpQJJknBTKqHIuJOuYV4WoZ1fQTs9g6+8/KyQjkSbExFVRSTCcrmMXC6H40IBh/k8bg9yMPeO0N7dR3t7B/79w0xIx9F1HQPWD9d14VL/WAJqASWi6v98y4Zh8ItptVrQNA1ap8MZDG2M2QniSczjEuKEiIiQfH7ilqnZdHsdRp/hmRbHNUwEjiMqmIcQNhoNZLNZZNJpbGTSONncgrq6jreVNbwuLUO/kKbCr29t3uBC6pssy6gzanUZ77UaRtUnBI/P8CtVhKomKvxVuOivt2jcJ7TzjQt2ZsxFAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact editing modal and consequent warning modal",
            "title": "Example of a high-impact editing modal and consequent warning modal",
            "src": "/static/a4df3e94ba0b5c7f17059d549f188b2e/fb070/05.png",
            "srcSet": ["/static/a4df3e94ba0b5c7f17059d549f188b2e/d6747/05.png 288w", "/static/a4df3e94ba0b5c7f17059d549f188b2e/09548/05.png 576w", "/static/a4df3e94ba0b5c7f17059d549f188b2e/fb070/05.png 1152w", "/static/a4df3e94ba0b5c7f17059d549f188b2e/e8e91/05.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a high-impact editing modal and consequent warning modal
        </Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "side-panel-1"
    }}>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, or there are too many editable fields for a modal, a slide-over panel can be used.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB2UlEQVQoz62T3Y7SQBTH9wmFULwDbtaL9Rn8iBUMhW5bSqVgoSIxAg8AJIR7XoIlJLgSueCCAC1f5e+cYyDUqImJTX6Z00znN2fOnN6cTif8r4dcNxQExwDt9hco+TxUTRejCvVeQ9F6H8IomMirKtKZd3jzNg1Z8OLVa9iVDzgcDixloe9vIcWf4kkkgpgURyQaRVQgSRJisZiYi/P73d1zaGLDbDYLRVGgGwZv8KnxOSzcbDa4vX0G07TgVF3U3I+o1WpwXZfHer2OSqWC4XD41+NehJ63QTKZhCp2M00ThqGjUChA13WG4lwuh06nI771sFwuOYn1eo3VasXxL0IPiUTiSmiEOAt7vR6OxyOLSEL4vo/dbvd7oaZpfLRSqXTBtm2GxP1+nxeThGpG7Pd7bLfbP2dIknK5fBFblsVxsVhk4Ww2w2g0wng8xvjhAZPJhEsQahsSplIpztBxnAskJqrVKssHgwEWiwWm0ym+Pj5iKvg+n8MTGYcypFrERWtkMhmuF4mvoeNSq3S7XV5EdTwFgWjgnxxFGQKKz0KqgSzLaDQaosHbaDabTKvVCsU0b4mj3xdNtHUD87SCby9lzG0HwbkP/+XXoyzoQigBYu8T4oKubvkHa9EX62/AxUAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact edit action in a side panel",
            "title": "Example of a high-impact edit action in a side panel",
            "src": "/static/8e2fda1604e266c563a716d99b963f09/fb070/06.png",
            "srcSet": ["/static/8e2fda1604e266c563a716d99b963f09/d6747/06.png 288w", "/static/8e2fda1604e266c563a716d99b963f09/09548/06.png 576w", "/static/8e2fda1604e266c563a716d99b963f09/fb070/06.png 1152w", "/static/8e2fda1604e266c563a716d99b963f09/e8e91/06.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a high-impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <p>{`High-impact side panel edits should also warn the user of destructive edits with a warning before changes are saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABrElEQVQoz62Ty07CUBCGfUIhFHfARhe8g5dIwXCpvVEoWKiIiYB7EhaErT6JC1ZsgEJp+Z05SQlN0MTEk/w5056cb/7pTM/2+z3+azHrjIMwCDEavaFSq0FRNdoVKI8q6lYjJt0wUVUUyKUH3MsyCnIR17d3sNtP2O12AiqAnreBlL7AeSKBlJRGIplEkiRJElKpFJ2lxXM+n4emUcJKBdVqFbquo0YJXvqvceBqtcLl5RVM04LTcdF1n9HtduG6rth7vR7a7TY+Pz5+LfcAXK9XyGazUCibaZqUWYNhGMINi2N2NB6PqRoPi8UCy+WS7q3h+z622y3CMDwGrpHJZI6AekwRcDKZnHQXBMFpoKqqorRms3mQbdtCDJ5Op+ISX+YSozJ/BLJDhrRarQPYsiwR1+v1vwFzuZxw6DjOQQxmdTodNBoNzGazWAOiCQ4IFgNyl9M0GqVSSXwvBh+Lyy2Xy6IpvLgJgU9jQg1hBZtNHLihF4VCAf1+nwZ8hMFgIDQcDmMxn1vUNJXKf9cMzIsVfN3ImNsOwmgO//LrsQseGzbA8j2Whx05jjjfgPscS9XbQIYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a warning screen in a side panel before a user saves changes",
            "title": "Example of a warning screen in a side panel before a user saves changes",
            "src": "/static/a164316795c7dce3b361dd091a232336/fb070/07.png",
            "srcSet": ["/static/a164316795c7dce3b361dd091a232336/d6747/07.png 288w", "/static/a164316795c7dce3b361dd091a232336/09548/07.png 576w", "/static/a164316795c7dce3b361dd091a232336/fb070/07.png 1152w", "/static/a164316795c7dce3b361dd091a232336/e8e91/07.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a warning screen in a side panel before a user saves changes
        </Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "full-page"
    }}>{`Full page`}</h3>
    <p>{`When an object was created in a full-page flow, or the volume of editable fields is high, use a full-page edit dialog.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABhUlEQVQoz52TXU7CQBSFXaFSIPyUVfgk7sAHl2LimyGuwZgCxQg8yU+Itva/QJH2OGfKhAImRpucznR655tz723PIK4sy+D7HmzbhuO4uVxXrAU/iu+kHAeflg3P8ySD1xlvX5sN2tdXqDV0VGt1lLQyypUqGk39RE1dh1ap4KKkQas3cN5q4bLdRrJe74FZmmI4GuPZ6KHX7cIwDPT7fQwGg71ME+ZOnL+Mhug9dPB0c4vXziPSPNUcmAq37x82JpM3mfZsNoNlWVitVlgul1KcJ0mSS7hJhIl4OIZ3d4+wbyI7AAqiJWpBWBiGcqTcXZ0o1ikIAinf96UCcUgo9gfigHS7LaQsyNxMRVEoxziOpZu1CKbokGtRFEkoDw4I5UFiTNN0D+SDDNgF0g0dqFRV6sdAtYf6Fcg0CVBAzvnuX8CiO9UU9fxnIDcsFgvR8Yns9nQ6xXw+l2sU3StYUSdA1T2O/GRUl6ljiIordvwAyC6rOqniq++u2OVic1QZVKz69b4BgG96g9Xkez4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full-page edit view",
            "title": "Example of a full-page edit view",
            "src": "/static/5ed5d0705f9c2d9d7c537f6c50b4da2a/fb070/08.png",
            "srcSet": ["/static/5ed5d0705f9c2d9d7c537f6c50b4da2a/d6747/08.png 288w", "/static/5ed5d0705f9c2d9d7c537f6c50b4da2a/09548/08.png 576w", "/static/5ed5d0705f9c2d9d7c537f6c50b4da2a/fb070/08.png 1152w", "/static/5ed5d0705f9c2d9d7c537f6c50b4da2a/e8e91/08.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a full-page edit view</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAACFklEQVQoz41TW2saURDOP+tDtFHSJBQKJU8phEAr7UNDwQv2qRZddXXXS1wf6mWNeRcpRKUPfUhX+ye8gIKFCF6bZtWvM4dak2JpF76dOed8883MGc4W6Fsul5hOJxiORhiNxwLj8QTT2WwjxpPJLw5xh0NMaM0a/G3xz7w18fKVA5aHO9ix2bFttcJK/qO9fcLeH9gXZ9sWC6x2Ox7YbDhxOPDj5mYtOJ/PoapxnJ6+gcvlgtPpFNbj8WyG2w2P1wv38xd4bd9FxPsW5mJxV3CBXF7He58PkUgUUjAIWZahKAqtI8JnG41GxV4ykcCZpiHxzofw8QnOFRXzuy1zhblcHpIkIRaLIRQKUcUqSqUSyuUyKpUKatUqPtVqqF5eIplMigRqMgGZfP3igq7tdi24IEFd14VQPB5HOBxGJpNBv9/H4PpaDGHwfYYZcadUSSabFVVzcpliONY0zfsVFovFNYlsKpWCYRgw6nU0rq7wzWhgVP+KwZcGPlC7MrW/4hYKhb8Lcqt8T9z+s6MjPD08xDHh48ETfLYdoLb7GGeBAKLxGGLE/acgZ2VBbl2jStLpNLS0BkUgjYiWgkJCKnHU/xFkoSBNOUBVMPx+v7Ah2gtJQSjcKgsSODkPZ6NgPp8XgUzgdhk8pBU42Qo8NAb7zMvSkO4J8rPp9XpoNptot9totVrodDobsTpnsM8x3W7399P7CevP4AZWBgudAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "title": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "src": "/static/8fab296783a516e6c469bdd95f46d28a/fb070/09.png",
            "srcSet": ["/static/8fab296783a516e6c469bdd95f46d28a/d6747/09.png 288w", "/static/8fab296783a516e6c469bdd95f46d28a/09548/09.png 576w", "/static/8fab296783a516e6c469bdd95f46d28a/fb070/09.png 1152w", "/static/8fab296783a516e6c469bdd95f46d28a/e8e91/09.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a modal warning users of the consequences of saving after a
  full-page edit
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "optional-extras"
    }}>{`Optional extras`}</h2>
    <h3 {...{
      "id": "summary-of-changes"
    }}>{`Summary of changes`}</h3>
    <p>{`Adding a summary of changes to the warning stage of a high-impact flow can help the user manage and understand all of the changes they have made.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABFklEQVQoz5WT22qDQBCG83a9KfSivSmkNHiX5/ABS5vWQ0EFFfF82FVbD/Gvs9RchIS4Az/DLD8fM8PsBhdimiasiUu+zblhMfV9j67rMAwDxnE8iWrS4juHXgVGUQTLsuB5HvI8R5ZlInPOhaSBQRDANE3Ytg3HcU7wtm2FpIFxHMN1XZEJTjlJEtF5URTyQBrR932EYSg6S9NUvBGURpcGMsZEJ7QvgpHq//2xqloPXKJpGtR1LfZVzYBiFp/fFkkBKZdlKcZbRmVz5nPN4gQ1jXw8rgfSDaqqipftFjtFwf51h7fHZ3j3T7DvHuApe4yMy3VIp6JpGnTDwLeugx++0H184uf9gF/DxDQf+U2gzLe75v0DwWGe3tPkAhUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a summary of changes in a modal",
            "title": "Example of a summary of changes in a modal",
            "src": "/static/b0e48c2411a525cc39b75c383846c3c9/fb070/11.png",
            "srcSet": ["/static/b0e48c2411a525cc39b75c383846c3c9/d6747/11.png 288w", "/static/b0e48c2411a525cc39b75c383846c3c9/09548/11.png 576w", "/static/b0e48c2411a525cc39b75c383846c3c9/fb070/11.png 1152w", "/static/b0e48c2411a525cc39b75c383846c3c9/e8e91/11.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a summary of changes in a modal</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "non-editable-fields"
    }}>{`Non-editable fields`}</h3>
    <p>{`When a small number of fields are not editable, display their set value in a disabled field.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAr0lEQVQoz8WT2QqEMAxF/f+Ps/W1H2Drk+DSzSXDDVjq4AzTvkzgkCjXaxLaht7iPM+Uv5Fr82joIZ6Ev2qaT8IYI7PvOx3HcaOow0tkraVxHDl77xPOOQohlBvi43Vd2RD5qkGVIQzmeU5mlyF+hDVUjTxNE+9x27YEnqs6hFnf92SMYbTWDOplWcoNh2Ggtm2p6zqSUjJCCFJK8SqKDTEWOsl3CPAeo///YNdevRfXdLJR6Xo8kQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a single non-editable field",
            "title": "Example of a single non-editable field",
            "src": "/static/1b3a6e93a72c1e28bbe6ec31e5322e44/fb070/10.png",
            "srcSet": ["/static/1b3a6e93a72c1e28bbe6ec31e5322e44/d6747/10.png 288w", "/static/1b3a6e93a72c1e28bbe6ec31e5322e44/09548/10.png 576w", "/static/1b3a6e93a72c1e28bbe6ec31e5322e44/fb070/10.png 1152w", "/static/1b3a6e93a72c1e28bbe6ec31e5322e44/e8e91/10.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a single non-editable field</Caption>
      </Column>
    </Row>
    <p>{`Where a majority of variables are not editable, consider using an option that will display only editable fields. In a small number of cases, make individual variables editable in modals.`}</p>
    <h3 {...{
      "id": "success-notifications"
    }}>{`Success notifications`}</h3>
    <p>{`An optional success notification can be used to confirm that the user’s changes have been saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA4ElEQVQoz61S2QrCMBD0/3/JF0FRxKtYtfGssUZF61Wvmm0zRkURKRjRDcPsZDfDBjaFP0fqVSilnmyC1zeJhu+mSEJC78cJYxXfdcKXIl27HqMJH8XhTiDjV2DNGSrTBsoTDWGjpNELBdiRY0WBuWE/8JDf2sjyMtIsd+O8sFDQcEKOZjjEQm7MDV09ISMP1rqN4sxGTXPjMEDz6KJDYzg0gk9bc0O+n8I5cbQCF/VVF5bPUJ07qC876EmBduhhKb8wpDjCmSRkTDqnmyYVPe+viHT+1dqYhPHa/HWxf40LJbWs/uLqtEsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a successful editing toast notification",
            "title": "Example of a successful editing toast notification",
            "src": "/static/384b4e5d7826b2ff39637e40dd5d41db/fb070/12.png",
            "srcSet": ["/static/384b4e5d7826b2ff39637e40dd5d41db/d6747/12.png 288w", "/static/384b4e5d7826b2ff39637e40dd5d41db/09548/12.png 576w", "/static/384b4e5d7826b2ff39637e40dd5d41db/fb070/12.png 1152w", "/static/384b4e5d7826b2ff39637e40dd5d41db/e8e91/12.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a successful editing toast notification</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      